import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyFiles = lazyWithRetry(() => import("./TeamFiles"));

const TeamFiles = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyFiles {...props} />;

export default TeamFiles;
